import { render, staticRenderFns } from "./summary-section-layout.vue?vue&type=template&id=1f2340ab&scoped=true"
import script from "./summary-section-layout.vue?vue&type=script&lang=ts"
export * from "./summary-section-layout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2340ab",
  null
  
)

export default component.exports